import React from 'react';
import {View} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import {observer} from 'mobx-react-lite';

import Text from '../../components/themed/Text';
import ContentView from '../../components/ui-controls/layout/ContentView';
import config from '../../config';
import CelebrationIcon from '../../images/brand/svg/icons/Celebration.svg';
import Button from '../themed/Button';
import _ from 'lodash';

type SuccessGenericProps = {
  onPressHome: () => void;
  text: string;
};

/**
 * This is a generic success screen component
 */
const SuccessGeneric = observer(({onPressHome, text}: SuccessGenericProps) => {
  return (
    <KeyboardAwareScrollView
      style={{backgroundColor: 'white'}}
      keyboardShouldPersistTaps="always">
      <ContentView>
        <View
          style={{
            padding: 20,
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <CelebrationIcon width={113} height={115} />
        </View>
        <Text variant="heading1">Congrats!</Text>
        <Text variant="body2">{text}</Text>
        <View style={{gap: 8, marginTop: 40}}>
          <Button
            secondary
            title={`GO TO ${_.toUpper(config.APP_NAME)} HOME`}
            onPress={onPressHome}
          />
        </View>
      </ContentView>
    </KeyboardAwareScrollView>
  );
});

export default SuccessGeneric;
